import React from 'react';
import { Component } from '@poa/core';
import { when } from '@poa/state';
import Spinner from 'react-spinkit';

import { ReactComponent as ConstructorIcon } from '../img/svgo/construction.svg';

import Navbar from './navbar';

class RouteLoading extends React.Component {
  state = { loading: true, error: false };

  componentDidMount() {
    when(() => this.props.meta.hasError, () => this.setState({ error: true }));
    when(() => this.props.meta.loaded, () => this.setState({ loading: false }));
  }

  render() {
    if (this.state.error) {
      return (
        <div className="content">
          {this.props.withoutNavbar ? null : <Navbar />}
          <div className="inner-scroll" style={{ paddingTop: '75px', textAlign: 'center' }}>
          <div class="warning-content">
        <h1>Under Construction</h1>

        <ConstructorIcon/>
        
        <p>
            Please forgive the inconvenience. <br />
            We are currently initializing the problem.
        </p>

    </div>
          </div>
        </div>
      );
    }

    if (this.state.loading) {
      return (
        <div className="content">
          {this.props.withoutNavbar ? null : <Navbar />}
          <div className="inner">
            <div className="spinner-loading" style={{ paddingTop: '75px', textAlign: 'center' }}>
              <Spinner name="folding-cube" fadeIn="none" />
            </div>
          </div>
        </div>
      );
    }

    return this.props.children || this.props.render();
  }
}

export default Component()(RouteLoading);
